module.exports = __webpack_public_path__ + "img/file07.313a0f21.png";